/* unplugin-vue-components disabled */import script from "./recursiveComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./recursiveComponent.vue?vue&type=script&setup=true&lang=js"

import "./recursiveComponent.vue?vue&type=style&index=0&id=4298ceb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4298ceb6"]])

export default __exports__